export function escapeRegex(text: string) {
	return text.replace(/[/\-\\^$*+?.()|[\]{}]/g, "\\$&");
}

export function unescapeRegex(text: string) {
	return text.replace(/\\(.)/g, "$1");
}
